import { RouteRecordRaw } from 'vue-router';
import { retailerOnlyGuard } from '@core/routes/router-guard';

const discountsRoutes: RouteRecordRaw[] = [
  {
    name: 'discounts',
    path: '/discounts',
    component: async () => import('./pages/discounts.vue'),
    beforeEnter: retailerOnlyGuard,
  },
];

export default discountsRoutes;
